import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import BlogDetail from './components/BlogDetail';
import Home from './Home';
import Disclaimer from './components/footer/disclaimer';
import TermsOfUse from './components/footer/terms-of-use';
import CaliforniaPolicy from './components/footer/california-policy';
import PrivacyPolicy from './components/footer/privacy-policy';
import Security from './components/footer/security';
import BlogNotFound from './components/BlogNotFound';
import SiteHeader from './components/SiteHeader';
import SiteFooter from './components/SiteFooter';
import ScrollToTop from './components/ScrollToTop';
import LandscapePortraitLock from './components/LandscapePortraitLock';

const App = () => {
  return (
    <>
      <LandscapePortraitLock />
      <Router>
        <ScrollToTop />
        <SiteHeader />
        <Routes>
          <Route path="/blog" element={<Home />} />
          <Route path="/blog/" element={<Home />} />
          <Route path="/blogs" element={<Navigate to="/blog" replace />} />
          <Route path="/blogs/" element={<Navigate to="/blog" replace />} />
          <Route path="/blog/disclaimer" element={<Disclaimer />} />
          <Route path="/blog/terms-of-use" element={<TermsOfUse />} />
          <Route path="/blog/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/blog/california-policy" element={<CaliforniaPolicy />} />
          <Route path="/blog/security-policy" element={<Security />} />
          <Route path="/blog/:slug/" element={<BlogDetail />} />
          <Route path="/blog/:slug" element={<BlogDetail />} />
          <Route path="/blog/404" element={<BlogNotFound />} />
          <Route path="/blog/*" element={<BlogNotFound />} />
        </Routes>
        <SiteFooter />
      </Router>
    </>
  );
};

export default App;
